import React, {ReactNode, FunctionComponent, useState} from 'react';

type HeaderNavigationProps = {
    children: ReactNode
}

const HeaderNavigation: FunctionComponent<HeaderNavigationProps> = (({children}: HeaderNavigationProps) => {
    const [carsaleIsShowing, setcarsaleIsShowing] = useState(false)
    const [servicesIsShowing, setservicesIsShowing] = useState(false)

    const services = [
        {
            name: 'Inspektion',
            href: 'https://www.repareo.de/inspektion/',
            icon: <i className={'fa-kit fa-car-wrench-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'HU/AU',
            href: 'https://www.repareo.de/hauptuntersuchung-hu-au/',
            icon: <i className={'fa-kit fa-clipboard-list-check-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Ölwechsel',
            href: 'https://www.repareo.de/oelwechsel/',
            icon: <i className={'fa-kit fa-oil-can-drip-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Reifen&shy;wechsel',
            href: 'https://www.repareo.de/reifenwechsel/',
            icon: <i className={'fa-kit fa-tire-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Zahnriemen&shy;wechsel',
            href: 'https://www.repareo.de/zahnriemenwechsel/',
            icon: <i className={'fa-kit fa-engine-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Kupplungs&shy;wechsel',
            href: 'https://www.repareo.de/kupplung-wechseln/',
            icon: <i className={'fa-kit fa-gears-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Klima&shy;service',
            href: 'https://www.repareo.de/klimaservice/',
            icon: <i className={'fa-kit fa-temperature-snow-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Bremsen&shy;wechsel',
            href: 'https://www.repareo.de/bremsen-wechseln/',
            icon: <i className={'fa-kit fa-bagel-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        }, {
            name: 'Querlenker wechseln',
            href: 'https://www.repareo.de/querlenker-wechseln/',
            icon: <i className={'fa-kit fa-steering-wheel-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Motor&shy;tausch',
            href: 'https://www.repareo.de/austauschmotor/',
            icon: <i className={'fa-kit fa-engine-warning-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Motor&shy;schaden',
            href: 'https://www.repareo.de/motorschaden/',
            icon: <i className={'fa-kit fa-engine-warning-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Glas&shy;reparatur',
            href: 'https://www.repareo.de/autoscheibe/',
            icon: <i className={'fa-kit fa-gears-light font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
    ]
    const carsale = [
        {
            name: 'Auto&shy;bewertung',
            href: 'https://www.repareo.de/autobewertung-kostenlos/',
            icon: <i className={'fa-kit fa-car font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Auto&shy;ankauf',
            href: 'https://www.repareo.de/auto-verkaufen/',
            icon: <i className={'fa-kit fa-car font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Unfall&shy;gutachten',
            href: 'https://lp.repareo.de/gutachten/unfallgutachten-tuv-rheinland',
            icon: <i className={'fa-kit fa-car-burst font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
        {
            name: 'Wert&shy;gutachten',
            href: 'https://lp.repareo.de/gutachten/wertgutachten-tuv-rheinland',
            icon: <i className={'fa-kit fa-certificate font-normal fa-fw text-primary text-2xl mr-3 align-middle'}/>,
        },
    ]

    function onlyOne(checkboxID: string) {
        var checkboxes = document.getElementsByName('navCheck')
        var checkbox = document.getElementById(checkboxID);
        var isMobile = window.innerWidth < 976;
        checkboxes.forEach((item) => {
            if (item !== checkbox && item instanceof HTMLInputElement && !isMobile) item.checked = false
        })
    }

    function toggleDropdowns(showCarsale: boolean, showServices: boolean) {
        var isMobile = window.innerWidth < 976;
        if(!isMobile){
            setcarsaleIsShowing(showCarsale);
            setservicesIsShowing(showServices);
        }
    }

    return (
        <div className={'subPageNav'} id={'nav-open'}>
                <nav className={`navigation px-6 lg:bg-white -ml-6 lg:ml-0`}>
                    <ul className={'lg:flex items-center'}>
                        <li className={servicesIsShowing ? ' lg:text-gray-900 lg:ring-2 lg:ring-primary-500 lg:ring-offset-2 lg:outline-none lg:rounded-md' : ''}>
                            <input type="checkbox" id="servicesIsShowing" name={'navCheck'}
                                   onChange={() => onlyOne('servicesIsShowing')}/>
                            <label htmlFor="servicesIsShowing"
                                   className={'servicesIsShowing_label cursor-pointer no-underline text-base font-semibold text-gray-900 lg:font-medium lg:text-gray-700 hover:text-gray-900 text-left lg:text-center w-full inline-block lg:flex px-5 py-3 lg:p-0 relative items-center'}
                                   onClick={() => toggleDropdowns(false, !servicesIsShowing)}>
                                Werkstatt Services
                                <i className={`fa-kit fa-chevron-down fa-fw text-primary text-lg align-middle relative right-0 ${servicesIsShowing ? 'rotate-180 transform float-right text-primary-500 ml-2' : 'float-right text-primary-500 ml-2'}`}/>
                            </label>
                            <div className="grid grid-cols-2 gap-4 overflow-x-hidden">
                                <div
                                    className="relative lg:absolute lg:shadow-lg z-[25] -ml-4 w-screen transform lg:left-[33%] lg:ml-0 lg:max-w-2xl lg:-translate-x-1/2 opacity-100 translate-y-0"
                                    id={'navServicesList'}>
                                    <div className="overflow-hidden rounded-lg shadow-lg">
                                        <div
                                            className="relative grid gap-x-6 gap-y-6 bg-white px-10 lg:p-8 sm:gap-x-8 grid-cols-2 lg:grid-cols-3 text-left">
                                            {services.map((service) => (
                                                <a key={service.name}
                                                   href={service.href}
                                                   title={service.name}
                                                   className={'col-span-2 xs:col-span-1 no-underline font-semibold text-gray-900 leading-6 flex items-center'}>
                                                    {service.icon}
                                                    <span dangerouslySetInnerHTML={{__html: service.name}}/>
                                                </a>
                                            ))}
                                        </div>
                                        <div className="lg:bg-gray-50 px-12 py-4 lg:p-8">
                                            <a href="https://www.repareo.de/werkstatt-profilseiten/"
                                               className="-m-3 flow-root rounded-md py-3 md:p-3 hover:bg-gray-100 no-underline">
                                                <div className="flex items-center">
                                                    <i className={`fa-kit fa-garage fa-fw text-gray-700 text-2xl mr-3`}/>
                                                    <div className="text-base font-medium text-gray-700">
                                                        <span>Werkstätten</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <a href="https://www.repareo.de/hauptuntersuchung-hu-au/"
                               className="no-underline text-base font-semibold text-gray-900 lg:font-medium lg:text-gray-700 hover:text-gray-900 px-5 py-3">
                                HU/AU
                            </a>
                        </li>
                        <li className={carsaleIsShowing ? ' lg:text-gray-900 lg:ring-2 lg:ring-primary-500 lg:ring-offset-2 lg:outline-none lg:rounded-md' : ''}>
                            <input type="checkbox" id="carsaleIsShowing" name={'navCheck'}
                                   onChange={() => onlyOne('carsaleIsShowing')}
                            />
                            <label htmlFor="carsaleIsShowing"
                                   className={'carsaleIsShowing_label cursor-pointer no-underline text-base font-semibold text-gray-900 lg:font-medium lg:text-gray-700 hover:text-gray-900 text-left lg:text-center w-full inline-block lg:flex px-5 py-3 lg:p-0 relative items-center'}
                                   onClick={() => toggleDropdowns(!carsaleIsShowing, false)}>
                                Autoankauf & Bewertung
                                <i className={`fa-kit fa-chevron-down fa-fw text-primary text-lg align-middle float-right relative right-0 ${carsaleIsShowing ? 'rotate-180 transform ml-2' : 'ml-2'}`}/>
                            </label>

                            <div className="grid grid-cols-2 gap-4 overflow-x-hidden">
                                <div
                                    className="relative lg:absolute lg:shadow-lg lg:left-[60%] z-[25] w-screen lg:max-w-xs lg:-translate-x-1/2 transform sm:px-0 -ml-4"
                                    id={'navCarsaleList'}>
                                    <div
                                        className="overflow-hidden rounded-lg shadow-lg">
                                        <div className="relative grid grid-cols-2 lg:grid-cols-1 gap-6 bg-white px-10 lg:px-5 plg:y-6 sm:gap-8 pb-6 lg:p-8 text-left">
                                            {carsale.map((carsaleItem) => (
                                                <a key={carsaleItem.name}
                                                   href={carsaleItem.href}
                                                   title={carsaleItem.name}
                                                   className={'col-span-2 xs:col-span-1 no-underline font-semibold text-gray-900 leading-6 flex items-center'}>
                                                    {carsaleItem.icon}
                                                    <span dangerouslySetInnerHTML={{__html: carsaleItem.name}}/>
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <a href="https://www.repareo.de/ueber-uns-repareo/"
                               className="no-underline text-base font-semibold text-gray-900 lg:font-medium lg:text-gray-700 hover:text-gray-900 px-5 py-3">
                                Über uns
                            </a>
                        </li>
                    </ul>
                </nav>
                {children}
        </div>
    )
})

export default HeaderNavigation
